import type { SVGProps } from 'react';

/** Figma `metric-vibrato.svg` — `tools/make-icon-components.py`가 만든다. 손으로 고치지 않는다. */
export const MetricVibratoIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g id="Frame">
      <path
        id="Vector"
        d="M1.81818 10C3.18182 10 3.18182 12.7273 4.54545 12.7273C5.90909 12.7273 5.90909 10 7.27273 10C8.63636 10 8.63636 12.7273 10 12.7273C11.3636 12.7273 11.3636 10 12.7273 10C14.0909 10 14.0909 12.7273 15.4545 12.7273C16.8182 12.7273 16.8182 10 18.1818 10"
        stroke="#E58C1A"
        strokeWidth="1.6"
        strokeLinecap="round"
      />
    </g>
  </svg>
);
